import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'

export type CachedImage = { url: string; isReady: boolean; isEmpty?: boolean }

export type CacheImageUrl = (imageId: string, url: string, isReady?: boolean, isEmpty?: boolean) => void

// map of image ID to the URL the editor should show for it
export const campaignImageCacheAtom = atom<Record<string, CachedImage>>({})

const noImage: CachedImage = { url: '', isReady: true }

export const useImageCache = (): { getImage: (imageId: string) => CachedImage } => {
	const cache = useAtomValue(campaignImageCacheAtom)

	const getImage = useCallback((imageId: string): CachedImage => cache[imageId] ?? noImage, [cache])

	return { getImage }
}

export const useImageCacheWriter = (): { cacheImageUrl: CacheImageUrl } => {
	const setCache = useSetAtom(campaignImageCacheAtom)

	const cacheImageUrl = useCallback<CacheImageUrl>((imageId, url, isReady = true, isEmpty = false) => {
		setCache((prev) => {
			const cached = prev[imageId]
			if (cached?.url === url && cached.isReady === isReady && !!cached.isEmpty === isEmpty) {
				return prev
			}

			return { ...prev, [imageId]: isEmpty ? { url, isReady, isEmpty } : { url, isReady } }
		})
	}, [setCache])

	return { cacheImageUrl }
}
